//
// Module for the Batch Adjustment wizard Pay Component Step Grid (partial)
//
rs.module("jobs/criteria/batchadjustment/paycomponentstepgrid",

    ["controls/components/event-banner",
     "jobs/criteria/batchadjustment/paycomponentstep"],

    function (eventBanner, payComponentStep) {

        // Initialize the module
        function initialize(grid, availablePayComponentKey) {

            // set grid variable for access on dependent JS module (_paycomponentstep.js)
            payComponentStep.setGrid(grid);

            // Get the wizard's next button and disable it when grid first displays (if a Pay Component record is not already selected)
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            wizardNextButton.setDisabled(availablePayComponentKey ? false : true);

            var _executeSelectionChanged;

            if (grid) {

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want to react in that case.
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked.
                    if (_executeSelectionChanged && values.length > 0) {

                        // clear any messages in the message banner
                        eventBanner.removeAllMessages();

                        // Enable the wizard's next button                    
                        wizardNextButton.setDisabled(false);
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);